// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1612001922
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { Call } from './models/communication/call';

@Injectable({
  providedIn: 'root',
})
export class CallsApiService {
  constructor(protected http: HttpClient) {}

  addCall(call: Call): Observable<Call> {
    const url = environment.chiliSauceApiRoot + `/api/Calls`;
    return this.http.post<Call>(url, call);
  }

  updateCall(call: Call): Observable<Call> {
    const url = environment.chiliSauceApiRoot + `/api/Calls`;
    return this.http.put<Call>(url, call);
  }
}
